import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { AuthShell } from "@/pages/auth/AuthShell";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { apiErr } from "@/lib/api";
import { toast } from "sonner";
import { Loader2, ShieldCheck } from "lucide-react";

export default function AdminLogin() {
  const { login, logout } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      if (u.role !== "admin") {
        await logout();
        toast.error("Accès réservé aux administrateurs.");
        return;
      }
      toast.success(`Bienvenue, ${u.first_name} !`);
      navigate("/admin");
    } catch (err) { toast.error(apiErr(err)); } finally { setLoading(false); }
  };

  return (
    <AuthShell title="Administration" subtitle="Accès réservé au Super Admin du portail">
      <div className="flex justify-center -mt-2 mb-4">
        <span className="w-12 h-12 rounded-2xl bg-rdcred/15 text-rdcred flex items-center justify-center"><ShieldCheck size={24} /></span>
      </div>
      <form onSubmit={submit} className="space-y-3">
        <Input type="email" placeholder="Email administrateur" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="admin-login-email" />
        <Input type="password" placeholder="Mot de passe" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="admin-login-password" />
        <Button type="submit" disabled={loading} className="w-full h-11 font-semibold bg-rdcred hover:bg-rdcred/90" data-testid="admin-login-submit">
          {loading ? <Loader2 className="animate-spin" size={18} /> : "Se connecter à l'administration"}
        </Button>
      </form>
      <p className="text-[11px] text-center text-muted-foreground mt-5">Cet espace est strictement réservé à l'administration du portail. Toute tentative d'accès est journalisée.</p>
    </AuthShell>
  );
}
